module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/pause.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/pause.png
// module id = 1073
// module chunks = 418